import ChangePasswordForm from './change-password-form';
import CreatePasswordForm from './create-password-form';
import ForgotPasswordForm from './forgot-password-form';
import ResetPasswordForm from './reset-password-form';
import LoginForm from './login-form';
import RegisterForm from './register-form';

export {
  ChangePasswordForm,
  CreatePasswordForm,
  ForgotPasswordForm,
  ResetPasswordForm,
  LoginForm,
  RegisterForm,
};
